import { Navigate, useParams } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { PageHero } from "@/components/PageHero";
import { FadeUp } from "@/components/Reveal";

export default function NewsArticle() {
  const { slug } = useParams();
  const { content } = useLang();
  const article = (content.news || []).find((a) => a.slug === slug);
  if (!article) return <Navigate to="/actualites" replace />;

  return (
    <article data-testid="news-article">
      <PageHero label={article.title} image={article.image} compact titleOnImage />
      <section className="bg-white">
        <div className="container-x pt-12 pb-20 md:pt-16 md:pb-28">
          <FadeUp className="max-w-3xl">
            <p className="earmark text-[var(--ink-3)]" data-testid="news-article-date">{content.ui.publishedOn} {article.date}</p>
            <h2 className="mt-5 font-pov text-2xl md:text-3xl text-[#1d1d1d]" data-testid="news-article-subtitle">{article.subtitle}</h2>
            <div className="mt-10 space-y-6">
              {article.body.map((p, i) => (
                <p key={i} data-testid={`news-article-paragraph-${i}`} className="text-sm md:text-[15px] leading-relaxed text-[var(--ink-2)]">{p}</p>
              ))}
            </div>
            {article.cta && (
              <a href={article.ctaUrl || "#"} target={article.ctaUrl ? "_blank" : undefined} rel={article.ctaUrl ? "noopener noreferrer" : undefined} data-testid="news-article-cta" className="btn-dark mt-12">
                {article.cta} <ArrowRight size={16} />
              </a>
            )}
          </FadeUp>
        </div>
      </section>
    </article>
  );
}
